import { classNames } from "@greeter/util";
import css from "./SummaryTable.module.scss";

export type SummaryTableProps = {
  headers: Array<string>;
  rows: Array<Array<string>>;
  onClick?: () => void;
  theme?: "dark" | "light";
};

export function SummaryTable(props: SummaryTableProps) {
  return (
    <div className={css.SummaryTableContainer} onClick={props.onClick}>
      <table
        {...classNames(
          css.SummaryTable,
          (props.theme ?? "light") === "light" ? css.Light : css.Dark
        )}
      >
        <thead>
          {props.headers.map((h) => {
            return <th>{h}</th>;
          })}
        </thead>
        <tbody>
          {props.rows.map((r) => {
            return (
              <tr>
                {r.map((c) => {
                  return <td>{c}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
